// import Lottie from "lottie-react";
import { User } from "../../models/User";
import classes from './login.module.scss';
import { FC, useEffect, useState } from "react";
import { FaRegCheckCircle } from "react-icons/fa";
import Modal from '../../elements/Modal/modal';
import { UseHttpAssistant, UseUserAssistant } from "@codes-on-us/assistant";
import { UseRouteAssistant } from "../../utilities/RouteAssistant/RouteAssistant";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { toast } from "react-toastify";


const Login: FC = () => {

    var { GoTo } = UseRouteAssistant();
    const { Get, Post } = UseHttpAssistant()
    const { updateUser } = UseUserAssistant()
    const [offers, setOffers] = useState<any[]>([]);
    const [showOffers, setShowOffers] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const Logout = async () => await Post("/Auth/Logout", undefined, true);


    useEffect(() => {
        Logout();
    }, []);

    const handleSubmit = async (e: any) => {
        const formData = new FormData(e.currentTarget);
        const data = {
            email: formData.get('email'),
            password: formData.get('password'),
        };
        e.preventDefault();


        const response = await Post('/Auth/Login', data);
        console.log(response);
        if (response && response.failed === false) {
            var res = response as {
                value: {
                    user: any,
                    token: {
                        token: string;
                        tokenExpiry: string;
                    }
                };
                failed: boolean;
                message: string | null;
            }

            //setToken(res.value.token.token);

            var user = (await Get("/Auth/Ping")).value as User;
            updateUser(user)


            if (!user.isVerified) {
                GoTo.VerificationPage()
            } 
            else {
                window.location.href = '/pricing'
            }
        }
        else {
            toast.error('Wrong Credentials or Account Not Found');
        }
    };

    return (
        <div className={classes.module}>
            <div className={classes.login}>
                <div className={`${classes.logo} text-center p50`}>
                    <img src="/images/logo-dark.png" title="logo" alt="logo" />
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="ig input-wrapper">
                        <img className="before" src="/images/email.svg" alt="email" />
                        <input
                            name="email"
                            type="text"
                            className="large fullwidth"
                            placeholder="Email"
                        />
                    </div>
                    <div className="ig input-wrapper">
                        <img className="before" src="/images/password.svg" alt="password" />
                        <input
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            className="large fullwidth"
                            placeholder="Password"
                        />
                        {
                            !showPassword ?
                                <MdVisibilityOff className={`${classes.visibility} after`} onClick={() => { setShowPassword(true); }} /> :
                                <MdVisibility className={`${classes.visibility} after`} onClick={() => { setShowPassword(false); }} />
                        }

                    </div>
                    <button type="button" className={`ig-button text primary fullwidth ${classes.forgotPassLink}`}
                        onClick={GoTo.ForgetPasswordPage}>
                        Forgot Password?
                    </button>

                    <button type="submit" className="ig-button filled fullwidth">Login</button>
                </form>
                <div className={`ig ${classes.signUp}`}>
                    <span className="light">Don't have an account?</span>
                    <button className="text primary bold fullwidth"
                        onClick={GoTo.SignupPage}>
                        Sign up
                    </button>
                </div>
                <div className={`ig ${classes.footerLinks}`}>
                    <button className="text primary">Privacy Policy</button>
                    <span>|</span>
                    <button className="text primary">Terms of Use</button>
                </div>
            </div>
        </div>
    )
}

export default Login